import clsx from "clsx"
import { Icon } from "./Icon"

export const CullingBadgeIcon = (props: {
	variant: "keeper" | "candidate" | "reject"
	size?: number
	className?: string
}) => {
	const size = props.size ?? 16
	const glyphSize = Math.max(Math.round(size * 0.72), 8)
	const backgroundColor = {
		keeper: "#FACC15",
		candidate: "#22C55E",
		reject: "#EF4444",
	}[props.variant]

	return (
		<div
			className={clsx(
				"inline-flex shrink-0 items-center justify-center rounded-full",
				props.className,
			)}
			style={{
				width: size,
				height: size,
				minWidth: size,
				minHeight: size,
				backgroundColor,
			}}
		>
			{props.variant === "keeper" && (
				<Icon name="kid_star" size={glyphSize} className="fill-base-900" />
			)}
			{props.variant === "candidate" && (
				<div
					className="rounded-full bg-base-900"
					style={{
						width: glyphSize * 0.8,
						height: glyphSize * 0.8,
					}}
				/>
			)}
			{props.variant === "reject" && (
				<Icon name="close" size={glyphSize} className="fill-base-900" />
			)}
		</div>
	)
}

export const KeeperIcon = (props: { size?: number; className?: string }) => (
	<CullingBadgeIcon variant="keeper" size={props.size} className={props.className} />
)

export const CandidateBadgeIcon = (props: { size?: number; className?: string }) => (
	<CullingBadgeIcon variant="candidate" size={props.size} className={props.className} />
)

export const RejectBadgeIcon = (props: { size?: number; className?: string }) => (
	<CullingBadgeIcon variant="reject" size={props.size} className={props.className} />
)
